<template>
  <AppSection
          id="timesheet-config"
          type="section"
          :title="$getConst.pages.timesheet_config.timesheet_config_page_title"
          :is-section-loading="isLoading"
  >
  <AppSection
          id="timesheet-config-attachment"
          type="sub-section-1"
          :title="$getConst.pages.timesheet_config.timesheet_config_attachment"
          :checkBox="true"
          :checkBoxModel="timesheetConfig.has_attachment"
          @onChangeCheckBox="onChangeStatus"
          v-if="!isLoading && timesheetConfig"
    >

    <b-row>

      <b-col sm="6">
        <b-form-group  id="max-file-size" :label="$t($getConst.pages.timesheet_config.max_file_size_label) + ' *'" label-for="max-file-size-input">
          <b-form-input
                  id="max-file-size"
                  :disabled="hasWritePermission||!timesheetConfig.has_attachment"
                  v-model.trim="$v.timesheetConfig.max_file_size.$model"
                  :class="{ 'is-invalid': $v.timesheetConfig.max_file_size.$error }"
                  :placeholder="$t($getConst.pages.timesheet_config.max_file_size_label_placeholder) + ' *'"
                  size="lg"
                  required
          ></b-form-input>
          <AppFormFeedback  :errors="$v.timesheetConfig.max_file_size">
          </AppFormFeedback>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group  id="max-total-files-size" :label="$t($getConst.pages.timesheet_config.max_total_files_size_label) + ' *'" label-for="max-total-files-size-input">
          <b-form-input
                  id="max-total-files-size"
                  :disabled="hasWritePermission||!timesheetConfig.has_attachment"
                  v-model.trim="$v.timesheetConfig.max_total_files_size.$model"
                  :class="{ 'is-invalid': $v.timesheetConfig.max_total_files_size.$error }"
                  :placeholder="$t($getConst.pages.timesheet_config.max_total_files_size_label_placeholder) + ' *'"
                  size="lg"
                  required
          ></b-form-input>
          <AppFormFeedback  :errors="$v.timesheetConfig.max_total_files_size">
          </AppFormFeedback>
        </b-form-group>
      </b-col>

    </b-row>

    <AppConfirmButtons
            v-if="!hasWritePermission"
            :is-disabled="$v.timesheetConfig.$invalid"
            :is-loading="isLoading"
            @onSubmit="onSubmit"
            @onCancel="onCancel"
    />
  </AppSection>
  </AppSection>
</template>

<script>
    import AppSection from "../../../../components/common/sections/AppSection";
    import {required, integer, minValue} from "vuelidate/lib/validators";
    import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
    import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
    import {getTimesheetsConfigOfScope, updateTimesheetsConfig} from "../../../../api/timesheet.api";

    export default {
        name: "index",
        components: {AppConfirmButtons, AppFormFeedback, AppSection},
        props: {
            scope_id: null
        },
        data() {
            return {
                timesheetConfigData: null,
                isLoading: false,
                timesheetConfig: {
                    max_file_size: null,
                    max_total_files_size: null,
                    has_attachment: null,
                },
                hasWritePermission: !this.hasAnyOfPermissions(
                    [this.$getConst.permissions.writeTimesheetConfig]
                ),
                snotifyConfig: {
                    timeout: 5000,
                    titleMaxLength: 40,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                }
            }
        },
        validations: {
            timesheetConfig: {
                max_file_size: {required, integer, minValue: minValue(1)},
                max_total_files_size: {required, integer, minValue: minValue(1)},

            }
        },
        methods: {
            getTimesheetConfig() {
                this.isLoading = true;
                getTimesheetsConfigOfScope(this.scope_id).then(
                    (response) => {
                        this.timesheetConfigData = Object.assign({}, response.data);
                        this.timesheetConfig = response.data;
                        this.isLoading = false;
                    },
                    (error) => {
                      this.handleApiError(error);
                        this.isLoading = false;
                    }
                )
            },
            onSubmit() {
                this.isLoading = true;
                updateTimesheetsConfig(this.scope_id, this.timesheetConfig).then(
                    (response) => {
                        this.timesheetConfigData = Object.assign({}, response.data);
                        this.timesheetConfig = response.data;
                        this.isLoading = false;
                        this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
                    },
                    (error) => {
                      this.handleApiError(error);
                        this.isLoading = false;
                    }
                )
            },
            onCancel() {
                this.timesheetConfig = Object.assign({}, this.timesheetConfigData);
            },
          onChangeStatus(checked) {
            this.timesheetConfig.has_attachment=checked;
            updateTimesheetsConfig(this.scope_id, {"has_attachment":checked}).then(
              () => {
                this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
              },
              (error) => {
                this.handleApiError(error);
              }
            )
          }


        },
        created() {
            this.getTimesheetConfig();
        }
    }
</script>
